'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { ArrowRight } from 'lucide-react'
import Input from '@/components/elements/Input'
import { Button } from '@/components/elements/Button'
import { navigateUrl } from '@/utils/client-request'
import { useLoginForm } from '@/lib/commerce/hooks'
import { formatImageURL } from '@/utils/util'

export default function Login({ vendor }: { vendor?: any }) {
  const pathname = usePathname() || ''
  const f = useLoginForm({ defaultRedirect: '/', refreshAfter: true, clearErrorParam: true })

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        {vendor?.logo ? (
          <img src={formatImageURL(vendor.logo)} alt={vendor?.name || ''} className="h-8 max-w-32 w-auto object-contain" />
        ) : vendor?.name ? (
          <div className="text-[18px] font-bold tracking-tight text-foreground">{vendor.name}</div>
        ) : null}
      </div>

      <h1 className="text-[36px] sm:text-[40px] font-bold font-gilroy tracking-[-0.025em] leading-[1.05] text-foreground">
        Нэвтрэх
      </h1>
      <p className="mt-2 text-[14px] text-foreground/55">
        Цахим шуудан эсвэл утасны дугаараа оруулна уу.
      </p>

      <form onSubmit={f.handleLogin} className="mt-7 flex flex-col gap-4">
        <Input label="Имэйл эсвэл утасны дугаар" type="text" placeholder="example@shop.mn" value={f.emailOrPhone} onChange={(e: any) => f.setEmailOrPhone(e.target.value)} onKeyDown={f.handleKeyDown} autoFocus />
        <div>
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm font-medium leading-none">Нууц үг</span>
            <Link href={navigateUrl('/forgot', pathname)} className="text-[13px] font-medium text-foreground underline underline-offset-[3px] hover:text-foreground/70 transition">
              Мартсан уу?
            </Link>
          </div>
          <Input type="password" placeholder="••••••••" value={f.password} onChange={(e: any) => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} />
        </div>
        <Button type="submit" isLoading={f.loading} icon={ArrowRight} iconPosition="right" variant="outline" className="mt-2 w-full h-14 rounded-full! bg-foreground text-cream font-semibold! border-foreground hover:bg-foreground/90 hover:text-cream transition-all" loadingMessage="Нэвтэрч байна...">
          Нэвтрэх
        </Button>
      </form>

      <p className="mt-7 text-[14px] text-center text-foreground/65">
        Шинэ хэрэглэгч үү?{' '}
        <span onClick={f.routeToRegister} className="cursor-pointer font-semibold text-foreground underline underline-offset-[3px] hover:text-foreground/80 transition-colors">
          Бүртгүүлэх
        </span>
      </p>
    </div>
  )
}
